import { useRelevantQueryParams } from '@frontend/common';
import { useModals } from '@frontend/modal';
import { ReportClient } from '@frontend/report/api';
import { Report, ReportType } from '@frontend/report/types';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';

import { useAppDispatch } from '../../../redux/store';

export const useConsumptions = () => {
    const dispatch = useAppDispatch();
    const { currentAccount } = useAccountRepository();
    const [report, setReport] = useState<Report | null>(null);
    const { openModal, closeModal } = useModals();
    const reportModalId = 'vending-consumptions-report-modal';
    const exportData: { [key: string]: any } = { ...useRelevantQueryParams(['tab']) };

    useEffect(() => {
        ReportClient.fetchReports({ type: ReportType.VENDING_CONSUMPTIONS, account_id: currentAccount }).then((res) => {
            if (res.results.length > 0) {
                setReport(res.results[0]);
            }
        });
    }, [currentAccount]);

    return {
        dispatch,
        currentAccount,
        report,
        openModal,
        closeModal,
        reportModalId,
        exportData
    };
};
